import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { DialogProvider } from '@lemonade-hq/cdk';
import Layout from '@/components/shared/Layout';
import { PageWrapper } from '@/components/shared/Content';
import { PageProps } from '../../utils/types';
import { ReviewProduct } from '@/components/reviews/types';
import { SEO } from '@/components/shared/SEO';
import { ReviewsSection } from '@/components/reviews/ReviewsSection';
import { config } from '@/pageConfig/reviews/us/en';
import { CustomersReviews, Products, Trust } from '@/components/shared';
import { Experts } from '@/components/shared/Experts';
import { Hero } from '@/components/reviews/Hero';

export type ReviewsProps = NextPage<
  PageProps & {
    product?: ReviewProduct;
  }
>;

const ReviewsPage: ReviewsProps = ({ product }) => {
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    trackEvent('reviews_page.viewed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DialogProvider>
      <Layout overflow="hidden" pt={[60, 60, 100]} position="relative" headerActions={config.layout.headerActions}>
        <SEO {...config.seo} />
        <PageWrapper>
          <Hero {...config.hero} />
          <ReviewsSection initialProduct={product} videosDisclosure={config.videosDisclosure} />
          <CustomersReviews {...config.customersReviews} />
          <Experts {...config.experts} />
          <Products {...config.products} />
          <Trust {...config.trust} />
        </PageWrapper>
      </Layout>
    </DialogProvider>
  );
};

export default ReviewsPage;
